import styled from 'styled-components';

export const HeaderWrapper = styled.header`
  // background-color: #34495e;
  color: #fff;
  padding: 20px;
  text-align: center;
  border-radius: 4px;
  margin-bottom: 20px;

  @media (max-width: 800px) {
    margin-bottom: 35px;
  }

  h1 {
    margin: 0;
    font-size: 24px;
    margin-bottom: 10px;
  }

  h4 {
    margin: 0;
    font-size: 18px;
  }
`;
